<template>
  <a-drawer
    :title="title"
    :maskClosable="true"
    :width="drawerWidth"
    placement="right"
    :closable="true"
    @close="handleCancel"
    :visible="visible"
    style="  overflow: auto; padding-bottom: 53px"
  >
    <template slot="title">
      <div style="width: 100%">
        <span>{{ title }}</span>
        <span
          style="display: inline-block; width: calc(100% - 51px); padding-right: 10px; text-align: right"
        >
          <a-button
            @click="toggleScreen"
            icon="appstore"
            style="height: 20px; width: 20px; border: 0px"
          ></a-button>
        </span>
      </div>
    </template>

    <a-spin :spinning="confirmLoading">
      <a-form :form="form" style="margin-bottom: 30px;" layout="horizontal">
        <template v-if="!model.groupName && title == '编辑'">
          <a-form-item
            label="标签类型"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-select
              placeholder="请选择标签类型"
              v-decorator="['tagType', validatorRules.tagType]"
              :disabled="title == '编辑' ? true : false"
            >
              <a-select-option value="1" disabled>个人</a-select-option>
              <a-select-option value="2">企业</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item
            label="标签名称"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-input
              type="text"
              :maxLength="28"
              placeholder="请输入标签名称"
              v-decorator="['name', validatorRules.name]"
              @change="handleTagIsExists"
            />
          </a-form-item>
          <a-form-item
            label="次序"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-input-number
              id="number"
              :min="1"
              :max="100"
              v-decorator="['order', validatorRules.listnum]"
            />
          </a-form-item>
        </template>

        <template v-if="model.groupName || title == '新增'">
          <a-form-item
            label="标签类型"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-select
              placeholder="请选择标签类型"
              v-decorator="['tagType', validatorRules.tagType]"
              :disabled="title == '编辑' ? true : false"
            >
              <a-select-option value="1">个人</a-select-option>
              <a-select-option value="2">企业</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item
            label="分组名称"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <template>
              <a-input
                type="text"
                :max-length="30"
                placeholder="请输入分组名称"
                v-decorator="['groupName', validatorRules.groupName]"
                @change="handleIsExists"
              />
            </template>
            <!-- <template v-else>
              <a-select
                style="width: 100%"
                placeholder="请输入或选择标签组名称"
                mode="tags"
                :allowClear="allowClear"
                v-decorator="['groupName', validatorRules.groupName]"
                :open="open"
                @change="handleChange"
              >
                <a-select-option v-for="(item, index) in groupNameList" :key="index" :disabled="disabled" :value="item">
                  {{ item }}
                </a-select-option>
              </a-select>
            </template> -->
          </a-form-item>
          <a-form-item
            label="次序"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-input-number
              id="inputNumber"
              :min="1"
              :max="100"
              v-decorator="['order', validatorRules.grouplistnum]"
            />
          </a-form-item>
          <!-- <a-form-model ref="tagList">
            <a-form-model-item
              label="标签"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              v-for="(item, index) in tagList"
              :key="index"
            >
              <a-input
                type="text"
                v-model="item.name"
                placeholder="请输入标签名称"
                v-decorator="['name', validatorRules.name]"
                style="width: 30%; margin-right: 20px"
                @blur="changeInput(item.name)"
              />

              <a-input-number
                v-model="item.order"
                :min="1"
                :max="10"
                v-decorator="['listnum', validatorRules.listnum]"
              />
              <a-button style="margin: 0 20px" @click="deleteList(index)"> 删除 </a-button>
            </a-form-model-item>
          </a-form-model> -->

          <!-- <div v-for="(item, index) in tagList" :key="index" style="position: relative;">
               <a-form-item label="标签" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input
                    type="text"
                    placeholder="请输入标签名称"
                    v-decorator="['name',{
                      ...validatorRules.name,
                      initialValue:item.name,
                    } ]"
                    style="width: 30%; margin-right: 20px"
                    @blur="changeInput(item.name)"
                  />
                  <a-input-number
                      :min="1"
                      :max="10"
                      v-decorator="['listnum',{
                        ...validatorRules.listnum,
                        initialValue:item.order,
                      }]"
                      @change="numChange"
                    />
                   <a-button style="margin: 0 20px" @click="deleteList(index)"> 删除 </a-button>
                </a-form-item>
              <div class="listnum-error" v-if="showListNumErr">请输入标签次序号!</div>
          </div> -->
          <div
            v-for="(item, index) in tagList"
            :key="index"
            style="position: relative;"
          >
            <a-row>
              <a-col :span="12">
                <a-form-item
                  label="标签"
                  :labelCol="{ span: 10 }"
                  :wrapperCol="{ span: 12 }"
                >
                  <a-input
                    type="text"
                    placeholder="请输入标签名称"
                    v-decorator="[
                      'name' + (index + 1),
                      {
                        ...validatorRules.name,
                        initialValue: item.name
                      }
                    ]"
                    style="width: 100%; margin-right: 20px"
                    @change="nameChange($event, index)"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item
                  label=" "
                  :colon="false"
                  :labelCol="{ span: 0 }"
                  :wrapperCol="{ span: 14 }"
                  class="tag-sort"
                >
                  <a-input-number
                    :min="1"
                    :max="100"
                    v-decorator="[
                      'listnum' + (index + 1),
                      {
                        ...validatorRules.listnum,
                        initialValue: item.order
                      }
                    ]"
                    style="width: 50%; margin-right: 20px"
                    @change="numChange"
                    @focus="numBlur(index)"
                  />
                  <a-button @click="deleteList(index)"> 删除 </a-button>
                </a-form-item>
              </a-col>
            </a-row>
          </div>

          <a-button type="primary" style="margin-left: 80px" @click="addList()">
            添加
          </a-button>
        </template>
      </a-form>
    </a-spin>

    <div class="drawer-bootom-button" v-show="!disableSubmit">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleSubmit" type="primary" :loading="confirmLoading"
        >提交</a-button
      >
    </div>
  </a-drawer>
</template>

<script>
import pick from 'lodash.pick';
import moment from 'moment';
import Vue from 'vue';
// 引入搜索部门弹出框的组件
import JSelectPosition from '@/components/jeecgbiz/JSelectPosition';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import { getAction } from '@/api/manage';
import { addTagGroup, editTag } from '@/api/api';
import { disabledAuthFilter } from '@/utils/authFilter';
import JImageUpload from '../../../components/jeecg/JImageUpload';

export default {
  name: 'TagModal',
  components: {
    JImageUpload,
    JSelectPosition
  },
  data() {
    return {
      tagLength: 1,
      modalWidth: 800,
      drawerWidth: 700,
      modaltoggleFlag: true,
      confirmDirty: false,
      editId: '', //保存id
      disableSubmit: false,
      dateFormat: 'YYYY-MM-DD',
      validatorRules: {
        groupName: {
          rules: [{ required: true, message: '请输入分组名称!' }]
        },
        name: {
          rules: [{ required: true, message: '请输入标签名称!' }]
        },
        grouplistnum: {
          rules: [{ required: true, message: '请输入组别次序号!' }]
        },
        listnum: {
          rules: [{ required: true, message: '请输入标签次序号!' }]
        },
        tagType: {
          rules: [{ required: true, message: '请选择标签类型' }]
        }
      },
      title: '操作',
      visible: false,
      model: {},
      roleList: [],
      selectedRole: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 20 }
        }
      },
      formItemLayoutWithOutLabel: {
        wrapperCol: {
          xs: { span: 24, offset: 0 },
          sm: { span: 20, offset: 4 }
        }
      },
      uploadLoading: false,
      confirmLoading: false,
      headers: {},
      form: this.$form.createForm(this),
      picUrl: '',
      tagList: [{ name: '', order: '' }],
      //标识
      flag: '',
      tagFlag: '',
      tagName: '',
      tagGroupName: '',
      //1.编辑标签 2.编辑标签组
      type: 1,
      //下拉框回填所有的标签组名称
      groupNameList: [],
      disabled: false,
      open: true,
      allowClear: true,
      url: {
        list: process.env.VUE_APP_CMS_WECHATWORK + '/wechatwork/tag/data',
        tagGroupNameIsExists:
          process.env.VUE_APP_CMS_WECHATWORK +
          '/wechatwork/tag/tagGroupNameIsExists',
        tagNameIsExists:
          process.env.VUE_APP_CMS_WECHATWORK +
          '/wechatwork/tag/tagNameIsExists',
        getAllGroupName:
          process.env.VUE_APP_CMS_WECHATWORK + '/wechatwork/tag/getAllGroupName'
        // fileUpload: process.env.VUE_APP_GATEWAY_URL + process.env.VUE_APP_CMS_SYSTEM+"/sys/common/upload",
        // userWithDepart: process.env.VUE_APP_CMS_SYSTEM + "/sys/user/userDepartList", // 引入为指定用户查看部门信息需要的url
        // userId:process.env.VUE_APP_CMS_SYSTEM + "/sys/user/generateUserId", // 引入生成添加用户情况下的url
        // syncUserByUserName:process.env.VUE_APP_CMS_SYSTEM + "/process/extActProcess/doSyncUserByUserName",//同步用户到工作流
      },
      identity: '1',
      fileList: [],
      listnum: 1,
      numIndex: 0 //标签排序的输入框下标
    };
  },
  created() {
    const token = Vue.ls.get(ACCESS_TOKEN);
    this.headers = { 'X-Access-Token': token };
    //获取所有的标签组名称
    getAction(this.url.getAllGroupName, {}).then(res => {
      this.tagOperation = res.result;
      console.log(this.tagOperation);
    });
  },
  computed: {
    uploadAction: function() {
      return this.url.fileUpload;
    }
  },
  methods: {
    numChange(value) {
      // console.log(a,b);
      // console.log(this.form.getFieldValue('listnum'));
      this.tagList[this.numIndex].order = value;
    },
    numBlur(index) {
      this.numIndex = index;
    },
    nameChange(e, index) {
      console.log(this.numIndex);
      this.tagList[index].name = e.target.value;
    },
    handleIsExists() {
      const that = this;
      if (that.title == '编辑') {
        that.type = 1;
      }
      let groupName = document.getElementById('groupName').value;
      //编辑场景 标签组名称未变
      if (this.tagGroupName == groupName) {
        that.flag = 0;
        return true;
      }
      let tagType = this.form.getFieldValue('tagType');
      getAction(this.url.tagGroupNameIsExists, {
        groupName: groupName,
        tagType: tagType
      }).then(res => {
        if (res.success) {
          let result = res.result;
          if (result == 1) {
            that.flag = 1;
            that.$message.error('标签组名称已重复');
            return false;
          } else {
            that.flag = 0;
            return true;
          }
        }
      });
    },
    handleTagIsExists() {
      //编辑标签时 (编辑分为编辑标签组和编辑标签) 判断标签是否在所在标签组内名称重复
      const that = this;
      that.type = 2;
      //判断标签名称是否修改
      let name = document.getElementById('name').value;
      if (name == that.tagName) {
        that.tagFlag = 0;
        return true;
      }
      let tagType = this.form.getFieldValue('tagType');
      getAction(this.url.tagNameIsExists, {
        id: that.model.id,
        tagName: name,
        tagType: tagType
      }).then(res => {
        if (res.success) {
          if (res.result == 1) {
            that.tagFlag = 1;
            that.$message.error('标签名称在组内已重复!');
            return false;
          } else {
            that.tagFlag = 0;
            return true;
          }
        }
      });
    },
    // changeInput(value) {
    //   //同一个标签组内标签的名称不能重复
    //   console.log(this.tagList, '=================')
    //   const that = this;
    //   // let result = that.decideIsExists();
    //   // if (result > 0) {
    //   //   that.$message.error("标签名称不能重复");
    //   //   return false;
    //   // }
    // },
    decideIsExists: function() {
      //校验同一个标签组是否存在同名标签
      const that = this;
      let result = 0;
      if (that.tagList.length > 1) {
        for (let i = 0; i < this.tagList.length; i++) {
          //空标签不跳过查重
          if (that.tagList[i].name == '') {
            continue;
          }
          for (let j = i + 1; j < this.tagList.length; j++) {
            if (this.tagList[i].name == this.tagList[j].name) {
              result = 1;
              return result;
            }
          }
        }
      }
      return result;
    },
    loadGroupName() {
      getAction(this.url.getAllGroupName, {}).then(res => {
        if (res.success) {
          this.groupNameList = res.result;
        }
      });
    },
    testData() {
      const that = this;
      //1.编辑标签组 标签组名称不能重复  2.编辑标签 同一标签组内标签不能重复
      if (that.title == '编辑') {
        if (that.model.groupName) {
          if (that.flag == 1) {
            that.$message.error('标签组名称已重复');
            return false;
          }
        } else {
          if (that.tagFlag == 1) {
            that.$message.error('标签名称在组内已重复!');
            return false;
          }
        }
      }

      //新增 编辑标签组
      if (!!that.model.groupName || !!that.groupName) {
        let count = 0;
        let tagResult = that.decideIsExists();

        if (tagResult > 0) {
          that.$message.error('标签名称不能重复');
          return false;
        }

        for (let i in this.tagList) {
          if (this.tagList[i].name != '') {
            count = 1;
            break;
          }
        }
        if (count <= 0) {
          this.$message.error('请添加子标签!');
          return false;
        }
      }
    },
    sleep(n) {
      let start = new Date().getTime();
      while (true) {
        if (new Date().getTime() - start > n) {
          break;
        }
      }
    },
    addList() {
      this.tagList.push({ name: '', order: '' });
    },
    deleteList(index) {
      this.tagList.splice(index, 1);
    },
    addTagBtn(e) {
      console.log('点击增加标签:' + e);
      this.tagLength += 1;
    },
    //窗口最大化切换
    toggleScreen() {
      if (this.modaltoggleFlag) {
        this.modalWidth = window.innerWidth;
      } else {
        this.modalWidth = 800;
      }
      this.modaltoggleFlag = !this.modaltoggleFlag;
    },
    add() {
      this.tagList = [{ name: '', order: '' }];
      this.edit({});
    },
    edit(record) {
      console.log(record);
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      //判断是否是编辑标签组
      if (record.hasOwnProperty('groupName')) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.tagGroupName = this.model.groupName;
            if (this.model.tagType == 1) {
              this.model.tagType = '个人';
            } else if (this.model.tagType == 2) {
              this.model.tagType = '企业';
            }
            this.form.setFieldsValue(pick(this.model, 'tagType'));
            this.form.setFieldsValue(pick(this.model, 'groupName'));
            this.form.setFieldsValue(pick(this.model, 'order'));
            this.tagList = this.model.tag;
          });
        });
        //两种情况 1.新增 2.编辑标签
      } else {
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.title == '编辑') {
              this.tagName = this.model.name;
            } else {
              this.open = true;
              this.disabled = false;
              this.loadGroupName();
            }
            this.form.setFieldsValue(pick(this.model, 'tagType'));
            this.form.setFieldsValue(pick(this.model, 'name'));
            this.form.setFieldsValue(pick(this.model, 'order'));
            this.form.setFieldsValue(pick(this.model, 'id'));
            //tagList是一个全局变量 若新增时不清空 点击修改标签组后值就会回填到新增标签组的表单内
            this.tagList = [{ name: '', order: '' }];
          });
        });
      }

      this.editId = record.id;
    },
    close() {
      this.open = false;
      this.disabled = false;
      this.$emit('close');
      this.visible = false;
    },
    moment,
    handleSubmit() {
      const that = this;
      let result = that.testData();
      if (result != undefined && !result) {
        return false;
      }
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let formData = Object.assign(that.model, values);
          // console.log(formData);
          let obj;
          if (!that.model.id) {
            formData.tag = this.tagList;
            // formData.order = parseInt(document.getElementById("inputNumber").value);
            formData.order = values.order;
            //将数组转换成字符串
            // formData.groupName = formData.groupName.join();
            obj = addTagGroup(formData);
          } else {
            //修改类型 type 两种情况 1是修改标签 2是修改标签组
            formData.type = 1;
            if (!!that.model.groupName) {
              formData.type = 2;
              formData.name = that.model.groupName;
            }
            formData.order = that.model.order;
            formData.tag = this.tagList;
            formData.tagType = that.model.tagType;
            if (formData.tagType == '个人') formData.tagType = 1;
            if (formData.tagType == '企业') formData.tagType = 2;
            // console.log(formData.tagType);
            obj = editTag(formData);
          }
          obj
            .then(res => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              this.open = false;
              this.disabled = false;
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.open = false;
      this.disabled = false;
      getAction(this.url.list, {}).then(res => {
        this.$emit('ok', res);
      });
      this.close();
    },
    handleConfirmBlur(e) {
      const value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },

    normFile(e) {
      console.log('Upload event:', e);
      if (Array.isArray(e)) {
        return e;
      }
      return e && e.fileList;
    },
    beforeUpload: function(file) {
      var fileType = file.type;
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片');
        return false;
      }
      //TODO 验证文件大小
    },
    handleClick() {
      alert('111');
    },
    handleChange(value) {
      const that = this;
      console.log(value);
      that.groupName = value[0];
      if (that.groupName.length > 30) {
        this.$message.warning('分组名称不能超过30个字符！');
        this.$nextTick(() => {
          setTimeout(() => {
            this.form.setFieldsValue({ groupName: null });
          });
        });
        return;
      }
      if (value.length > 0) {
        that.open = false;
        that.disabled = true;
      } else {
        that.open = true;
        that.disabled = false;
      }
      // console.log(value);
      // this.picUrl = ''
      // if (info.file.status === 'uploading') {
      //   this.uploadLoading = true
      //   return
      // }
      // if (info.file.status === 'done') {
      //   var response = info.file.response
      //   this.uploadLoading = false
      //   console.log(response)
      //   if (response.success) {
      //     this.model.avatar = response.message
      //     this.picUrl = 'Has no pic url yet'
      //   } else {
      //     this.$message.warning(response.message)
      //   }
      // }
    },
    // 根据屏幕变化,设置抽屉尺寸
    resetScreenSize() {
      let screenWidth = document.body.clientWidth;
      if (screenWidth < 500) {
        this.drawerWidth = screenWidth;
      } else {
        this.drawerWidth = 700;
      }
    },
    identityChange(e) {
      if (e.target.value === '1') {
        this.departIdShow = false;
      } else {
        this.departIdShow = true;
      }
    }
  }
};
</script>

<style scoped>
.avatar-uploader > .ant-upload {
  width: 104px;
  height: 104px;
}
.ant-upload-select-picture-card i {
  font-size: 49px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.ant-table-tbody .ant-table-row td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}

.ant-form-item {
  margin-bottom: 20px;
}
</style>
<style scoped lang="less">
.tag-sort {
  /deep/.ant-form-item-label {
    .ant-form-item-required::before {
      color: #fff !important;
    }
  }
}
</style>
